'use client'

import { useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { useRouter } from "next/navigation"
import { Pattern1, Pattern2, Pattern3 } from "@/(front-desk)/utils/patterns"
import StatusBar from "@/(front-desk)/user/exhibit/(overview)/components/StatusBar"
import StageMessages from "@/(front-desk)/user/exhibit/stages/components/StageMessages"
import classNames from "classnames"
import Link from "next/link"
import dayjs from "dayjs"

export default function exhibitionOverview() {

    const router = useRouter()
    const account = useSelector((state) => state.account)
    const exhibition = useSelector((state) => state.exhibition)
    const global = useSelector((state) => state.global)
    const CMS = useSelector((state) => state.CMS)
    const [ overview, setOverview ] = useState(null)
    const exhibitionStage = exhibition.groupStages?.find((stage) => stage.shortcut === 'exhibition')
    const groupReview = exhibition.groupProject?.reviews?.registration

    useEffect(() => {
        handleRedirect()
        handleExhibitionTypes()
    }, [])

    function handleRedirect() {
        // redirect to stages page if user only has one exhibition project
        if (exhibition.groupProject && !exhibition.individualProjects) {
            if (
                groupReview?.result !== 'fail' ||
                (groupReview?.result === 'fail' && groupReview?.patch)
            ) {
                router.push('/user/exhibit/stages')
            }
        }
        else if (!exhibition.groupProject && exhibition.individualProjects.length === 1) {
            router.push(`/user/exhibit/stages?serial_no=${exhibition.individualProjects[0].serial_no}`)
        }
    }
    function handleExhibitionTypes() {
        setOverview([
            {
                name: 'group',
                title: '一般展位參展申請',
                pattern: <Pattern2 className="w-8 stroke-main-600 stroke-[1.5px]" />,
                stages: exhibition.groupStages,
                projects: exhibition.groupProjects,
                qualifications: [
                    '請派 1 位負責人代表送出申請。'
                ],
            },
            {
                name: 'individual',
                title: '決選入圍展位申請',
                pattern: <Pattern1 className="w-8 stroke-main-600 !stroke-[2px]" />,
                stages: exhibition.individualStages,
                projects: exhibition.individualProjects,
                qualifications: [
                    '限入圍放視大賞競賽決選名單團隊申請。',
                    '多個作品可以共同申請一個攤位，請推派 1 位代表人送出申請即可。'
                ],
            }
        ])
    }


    return (
        <>
        <div className="user-page-title">
            <div className="content">
                <div className="sub-title sm:mb-3">{global.currentExhibitYear} 放視大賞</div>
                <div className="title">參展申請</div>
            </div>
        </div>
        <main id="main" className="exhibit-entries flex-center flex-col gap-8 max-w-[65rem]">
            <div className="flex-center flex-col gap-4 text-center">
                <div className="text-[1.5rem] sm:text-[1.875rem] text-black-900 font-semibold">
                    {
                        exhibition.groupProject && '您目前參加：一般展位參展' ||
                        exhibition.individualProjects.length > 0 && '您目前參加：決選作品展出攤位' ||
                        '您尚未參加任何展覽行程'
                    }
                </div>
                <div className="text-[0.875rem] sm:text-[1rem] text-black-700 font-light">
                    { exhibitionStage &&
                        <>
                        本年度展覽期間為：
                        { dayjs(exhibitionStage.start)?.format('YYYY 年 MM 月 DD 日') }至
                        { dayjs(exhibitionStage.end)?.format(' YYYY 年 MM 月 DD 日') } <br/>
                        </>
                    }
                    如不確定自己屬於哪一類，請洽展覽管理小組 <a href={`mailto:${CMS.registries['cms.home.footer.email']}`}>{CMS.registries['cms.home.footer.email']}</a>
                </div>
            </div>
            <div className="w-full grid grid-cols-[repeat(auto-fit,minmax(20rem,1fr))] gap-8">
                { overview?.map((type, index) => {
                    const registrationStage = type.stages?.find((stage) => stage.shortcut === 'registration')
                    const ruleFile = registrationStage?.doctypes?.find((doctype) => doctype.shortcut === 'application')?.entries?.find((entry) => entry.subtype === 'exhibition-rules')
                    // const active = (!exhibition.groupProject && exhibition.individualProjects.length === 0 && registrationStage.current_status === 'ongoing') || type.project
                    const active = type.stages.find((stage) => stage.current_status === 'ongoing')
                    const block =
                        <div
                            key={`block-${index}`}
                            className={classNames('flex flex-col justify-between gap-6 max-w-[35rem] h-fit min-h-[24rem] mx-auto w-full border border-black-300 p-6 rounded-[0.5rem] bg-white', {
                                'opacity-[0.75]': !active,
                                'shadow-lg': active
                            })}
                        >
                            <div className="flex flex-col gap-4">
                                <div className="flex flex-col gap-1">
                                    {type.pattern}
                                    <div className="text-[1.125rem] font-medium">
                                        {type.title}
                                    </div>
                                </div>
                                <div className="text-black-700 text-[0.75rem]">
                                    <div className="font-semibold">參展資格：</div>
                                    { type.qualifications.map((text, index) => {
                                        return <div key={`text-${index}`}>{text}</div>
                                    })}
                                </div>
                                <div className="text-black-700 text-[0.75rem]">
                                    <div className="font-semibold">申請開放：</div>
                                    <div>{dayjs(registrationStage.start).format('YYYY 年 MM 月 DD 日 HH:mm')}</div>
                                    <div> ~ {dayjs(registrationStage.end).format('MM 月 DD 日 HH:mm')}</div>
                                </div>
                                { ruleFile &&
                                    <a
                                        className="btn btn-link-black-700"
                                        href={ruleFile.url || ruleFile.file}
                                        target="_blank"
                                        title={ruleFile.url && `另開新視窗查看${ruleFile.display_name}` || ruleFile.file && `下載檔案-${ruleFile.display_name}` || ''}
                                    >{ruleFile.display_name}</a>
                                }
                            </div>
                            <div className="flex flex-col gap-6">
                                { type.projects?.map((project, index) => (
                                    <StageMessages
                                        key={`project-${index}`}
                                        className="flex-col"
                                        // stage={registrationStage}
                                        stage={type.stages?.find((stage) => stage.current_status === 'ongoing' && stage.needs_review)}
                                        project={project}
                                    />
                                ))}
                            </div>
                            { account.data?.unverified_email
                                ?
                                <button
                                    className="btn-black-400 btn-round"
                                    disabled
                                >請完成信箱驗證</button>
                                :
                                <>
                                { type.name === 'group' && // 團體入口
                                 (groupReview?.result !== 'fail' || (groupReview?.result === 'fail' && groupReview?.patch)) &&
                                    <>
                                    { exhibition.groupProject
                                        ? // 有團體資料
                                        <Link
                                            className={classNames('btn btn-round h-fit', {
                                                'btn-black': exhibition.groupProject.user_is_captain,
                                                'btn-outline-black': !exhibition.groupProject.user_is_captain
                                            })}
                                            href={`/user/exhibit/stages`}
                                        >{exhibition.groupProject.user_is_captain ? '管理' : '查看'}申請進度 →</Link>
                                        : // 沒有團體資料
                                        <>
                                        { dayjs() < dayjs(registrationStage.start) && // 尚未開放
                                            <button
                                                className="btn-black-400 btn-round"
                                                disabled
                                            >尚未開放申請</button>
                                        }
                                        { dayjs() >= dayjs(registrationStage.start) && dayjs() < dayjs(registrationStage.end) &&  // 開放申請
                                            <Link
                                                className="btn btn-black btn-round h-fit"
                                                href={`/user/exhibit/${type.name}/${exhibition.groupStages[0].shortcut}`}
                                            >前往申請</Link>
                                        }
                                        { dayjs() >= dayjs(registrationStage.end) &&   // 申請截止
                                            <button
                                                className="btn-black-400 btn-round"
                                                disabled
                                            >申請階段已結束</button>
                                        }
                                        </>
                                    }
                                    </>
                                }
                                { type.name === 'individual' &&
                                    <>
                                    { exhibition.individualProjects.length === 0 && dayjs() < dayjs(registrationStage.start) && // 尚未開放
                                        <button
                                            className="btn-black-400 btn-round"
                                            disabled
                                        >尚未開放申請</button>
                                    }
                                    {/* 有獨立資料 */}
                                    { exhibition.individualProjects.map((project) => {
                                        const projectDetail =
                                            <StatusBar key={`project-${project.id}`} pattern={true}>
                                                <div>
                                                    <div className="mb-1">獨立參展申請編號：{project.serial_no}</div>
                                                    { project.linked_competition_project_list.map((competitionProject) => {
                                                        const competitionDetail =
                                                            <div
                                                                key={`competition-${competitionProject.id}`}
                                                                className="text-[0.875rem] text-black-700 font-light"
                                                            >
                                                                <span>{competitionProject.subcategory.name}：</span>
                                                                <span className="me-2">{competitionProject.serial_no}</span>
                                                                <span>{competitionProject.project_name}</span>
                                                            </div>
                                                        return competitionDetail
                                                    })}
                                                </div>
                                                <Link
                                                    className={classNames('btn btn-round h-fit', {
                                                        'btn-black': project.user_is_captain,
                                                        'btn-outline-black': !project.user_is_captain
                                                    })}
                                                    href={`/user/exhibit/stages?serial_no=${project.serial_no}`}
                                                >{project.user_is_captain ? '管理' : '查看'}申請進度</Link>
                                            </StatusBar>
                                        return projectDetail
                                    })}
                                    { dayjs() >= dayjs(registrationStage.start) && dayjs() < dayjs(registrationStage.end) &&  // 開放申請
                                        <>
                                        { exhibition.groupProject
                                            ? // 已有團體資料
                                            <>
                                            {/* 沒有獨立參展申請 */}
                                            { exhibition.individualProjects.length === 0 &&
                                                <StatusBar pattern={false}>
                                                    您已加入一般展位參展，不需額外申請「決選作品展出攤位」。
                                                </StatusBar>
                                            }
                                            </>
                                            : // 沒有團體資料
                                            <>
                                            {/* 沒有可申請的作品 */}
                                            { exhibition.overview.individual?.available_competition_projects.length === 0 &&
                                              exhibition.overview.individual?.individual_projects.length === 0 &&
                                                <StatusBar pattern={false}>
                                                    不需申請決選作品展出攤位
                                                </StatusBar>
                                            }
                                            {/* 有作品尚未申請 */}
                                            { exhibition.overview.individual?.available_competition_projects.length !== 0 &&
                                                <>
                                                <StatusBar pattern={true}>
                                                    <div className="">
                                                        {exhibition.overview.individual?.individual_projects.length === 0
                                                            ?
                                                            <div>
                                                                <span className="text-[1.75rem]">
                                                                    {exhibition.overview.individual?.available_competition_projects.length}
                                                                </span>
                                                                件作品進入決選，請確認決選展出方式！
                                                            </div>
                                                            :
                                                            <div>
                                                                尚有
                                                                <span className="text-[1.75rem]">
                                                                    {exhibition.overview.individual?.available_competition_projects.length}
                                                                </span>
                                                                件作品進入決選，請確認決選展出方式！
                                                            </div>
                                                        }
                                                    </div>
                                                    <Link
                                                        className="btn btn-black btn-round h-fit"
                                                        href={`/user/exhibit/${type.name}/${exhibition.groupStages[0].shortcut}`}
                                                    >建立申請</Link>
                                                </StatusBar>
                                                </>
                                            }
                                        </>
                                        }
                                        </>
                                    }
                                    { exhibition.individualProjects.length === 0 && dayjs() >= dayjs(registrationStage.end) &&   // 申請截止
                                        <StatusBar pattern={false}>
                                            申請已截止
                                        </StatusBar>
                                    }
                                    </>
                                }
                                </>
                            }
                        </div>
                        return block
                    }
                )}
            </div>
        </main>
        </>
    )
}
